<div class="container-fluid container-fluid-wrap">
    <sync-error [errcode]="errcode" style="position: relative; top: 10px;"></sync-error>
    <div class="row">
        <div class="invite-content-box col-sm-offset-3 col-sm-6">
            <h2 class="text-center" style="margin-bottom: 20px;" *ngIf="!isLegacyToCNC; else legacyContent">
                {{ acceptSuccess ? 'Transferring Account' : 'Transfer Account' }}
            </h2>
            <ng-template #legacyContent>
                <h2 class="text-center" style="margin-bottom: 20px;">
                    {{ acceptSuccess ? 'Account Transferring' : 'Account Transfer Notice' }}
                </h2>
            </ng-template>
            <div class="invite-content" *ngIf="spinner">
                <i class="fa fa-spin fa-spinner"></i>
                {{ isInviteChecked ? 'Working on invite...' : 'Verifying invite...'}}
            </div>
            <div *ngIf="isInviteChecked && isInviteValid && !spinner">
                <div class="invite-content" *ngIf="!declineSuccess && !acceptSuccess" style="text-align: left;">
                    <ng-container *ngIf="!show2FA && !isLegacyToCNC">
                        <p>You have been invited by <b>{{invitee}}</b> to transfer your Sync account to their organization. By clicking Accept:</p>
                        <ol>
                            <li><p>Ownership of your account will be transferred to the organization.</p></li>
                            <li><p>Your account will be upgraded to a Teams plan and inherit all Teams features.</p></li>
                            <li><p>Your files, folders, shares, links and selective sync settings will remain intact.</p></li>
                            <li><p>You will need to re-authorize Sync on your computers and devices when the transfer is complete.</p></li>
                            <li *ngIf="isPaid"><p>You will receive a pro-rated refund for the remaining balance on your current plan. Future billing will then be managed by the organization.</p></li>
                            <li *ngIf="isPaid"><p>Your account will temporarily stop syncing while the transfer is in progress. This can take up to 48 hours. We will email you as soon as the transfer is complete.</p></li>
                        </ol>
                    </ng-container>
                    <ng-container *ngIf="!show2FA && isLegacyToCNC">
                        <p>{{invitee}} has upgraded your organization’s account and has invited you to join them. By accepting this invitation:</p>
                        <ol>
                            <li><p>Your account will be upgraded to a Teams plan, inheriting all associated features.</p></li>
                            <li><p>Your files, folders, shares, links, and selective sync settings will remain unaffected.</p></li>
                            <li><p>You will need to re-authorize Sync on your computers and devices once the transfer is completed.</p></li>
                            <li><p>You will not be able to login to your Sync account while the migration is occuring. Upon completion, you may login into all your Sync devices.</p></li>
                        </ol>
                    </ng-container>

                    <ng-container *ngIf="show2FA">
                        <p>Please enter your 2FA (2-factor authentication) code received in your email. This code confirms that you were invited by <b>{{invitee}}</b>.</p>
                    </ng-container>
                    <hr />
                    <form *ngIf="isInviteChecked" [formGroup]="passwordForm" ngNativeValidate>
                        <ng-container *ngIf="!show2FA">
                            <div class="form-group">
                                <label>Your email address:</label>
                                <input type="email" name="email" id="email" class="input-lg form-control login-form-control" size="30"
                                    placeholder="Email" required formControlName="email" />
                                <span class="help-block" *ngIf="!isLegacyToCNC">
                                    <b>Note:</b> This email address was specified for the transfer. If you use a different
                                    email
                                    address you will have to get the organization administrator to send a new request.
                                </span>
                                <span class="help-block" *ngIf="isLegacyToCNC">
                                    <b>Note:</b> For a different email, contact the organization administrator for a new request. Accept the invitation and <a href="https://www.sync.com/blog/" target="_blank">enjoy the new features.</a>
                                </span>
                            </div>
                            <div class="form-group">
                                <label>Your Sync password:</label>
                                <input type="password" placeholder="Password" value="" id="password" formControlName="password" required
                                    class="input-lg form-control login-form-control" name="password"
                                    syncShowHidePassword
                                    identity="userinvitepass" />
                            </div>
                        </ng-container>
                        <ng-container *ngIf="show2FA">
                            <label>2FA Code:</label>
                            <input type="twofacode" name="twofacode" id="token" class="input-lg form-control login-form-control" size="30"
                                    required formControlName="twofacode" />
                        </ng-container>

                    </form>
                </div>
                <div *ngIf="!declineSuccess && !acceptSuccess" class="form-group">
                    <button style="width: 100%; height: 45px; margin-bottom: 15px;" [disabled]="!passwordForm.dirty || !passwordForm.valid || spinner"
                        (click)="userReaction(true)" class="btn sync-btn btn-primary" type="button">{{ isLegacyToCNC ? 'Continue' : 'Accept' }}</button>
                    <button *ngIf="!show2FA && !isLegacyToCNC" style="width: 100%; height: 45px;" (click)="userReaction(false)" class="btn btn-default" type="button">Decline</button>
                </div>
                <div class="invite-content" *ngIf="declineSuccess">
                    You have successfully declined the request to join the team.
                </div>
                <div class="invite-content" *ngIf="acceptSuccess">
                    Your account is being transferred to your organization. <b>{{invitee}}</b> will be notified that the transfer is occuring. <b>This may take some time.</b> You will not be able to access your account across all your devices while the transfer is in progress. You will receive an email when your account is ready to be used.
                    <br><br>
                    Before proceeding, ensure all your devices are running the latest version of the Sync app. <a href="https://www.sync.com/install/" target="_blank">Click here</a> to install the latest version.
                </div>
            </div>
            <div *ngIf="isInviteChecked && !isInviteValid && !spinner"
                class="invite-content content-override bg-warning">
                <div style="font-size: 16px; margin-bottom: 10px;">
                    <i class="fas fa-exclamation-triangle"></i>
                    <b> (#1600) This invite cannot be found</b>
                </div>
                There are three reasons this would happen:
                <ol>
                    <li>You've already accepted or declined this invite and the link is old.</li>
                    <li>Your invite expired or was removed by the owner before you had a chance to act on it. In this
                        case,
                        please contact the share owner to re-invite you. You will receive a new link to join this share
                        afterwards.</li>
                    <li>The address you were provided contains an error or was modified by your email client. Ensure the
                        link
                        was sent correctly and when you clicked it in your email, the entire link was clickable. You can
                        always
                        copy/paste the address into your browser.</li>
                </ol>
            </div>

            <hr />
            Questions? Get more information on transferring your account <a rel="noopener" href="https://www.sync.com/help/getting-started-with-pro-teams-plus/#bprotransferuser">
                here
            </a>    
        </div>
    </div>
</div>